<div class="dashboard-meetings-list">
  <div class="dml-toolbar">
    <div class="dml-labels">
      <span class="dml-badge-today">Today</span>
      <span class="dml-sub">Meeting TIME</span>
      <span class="dml-hint" *ngIf="!(searchText || '').trim()">Closest upcoming first</span>
    </div>
    <input
      type="search"
      class="form-control dml-search"
      placeholder="Search by meeting name…"
      [(ngModel)]="searchText"
      (ngModelChange)="onSearchChange()"
      autocomplete="off"
    />
  </div>

  <div class="dml-body">
    <div *ngIf="isLoading" class="dml-state text-muted">Loading meetings…</div>
    <div *ngIf="!isLoading && isEmpty" class="dml-state text-muted">No meetings.</div>

    <div class="dml-scroll" *ngIf="!isLoading && !isEmpty">
      <div
        *ngFor="let meeting of displayedMeetings"
        class="dml-row"
        [ngClass]="{
          'dml-today': meeting.meetingStatus == 'Today',
          'dml-future': meeting.meetingStatus == 'Future',
          'dml-past': meeting.meetingStatus == 'Past'
        }"
        (click)="openMeetingModal(meeting)"
      >
        <div class="dml-row-main">
          <div class="dml-type">{{ meetingTypeLabel(meeting) }}</div>
          <div class="dml-actions" *ngIf="showRegularEdit(meeting)">
            <button
              type="button"
              class="btn btn-sm btn-warning py-0 px-2"
              (click)="$event.stopPropagation(); loadRegularMeetingByID(meeting.meetingId)"
              title="Edit"
            >
              <span class="fa fa-pencil"></span>
            </button>
          </div>
        </div>
        <div class="dml-title">{{ meetingTitle(meeting) }}</div>
        <div class="dml-meta">
          <span>{{ meetingDateDisplay(meeting) }}</span>
          <span class="dml-sep">·</span>
          <span>{{ meetingTimeDisplay(meeting) }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
